var _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 210,
    viewBox: "0 0 187 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 110,
    width: 26,
    height: 100,
    rx: 3,
    fill: "#5C4322"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.7284 119.296C92.7834 118.524 94.2166 118.524 95.2716 119.296L167.065 171.829C169.406 173.542 168.194 177.25 165.293 177.25H21.7068C18.8058 177.25 17.5941 173.542 19.9353 171.829L91.7284 119.296Z",
    fill: "#00463A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9355 86.9582C92.0929 85.8604 93.9071 85.8604 95.0645 86.9582L160.288 148.823C162.255 150.689 160.935 154 158.224 154H27.7761C25.065 154 23.7445 150.689 25.7115 148.823L90.9355 86.9582Z",
    fill: "#00463A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0516 73.6643C92.1737 72.7058 93.8263 72.7058 94.9484 73.6643L150.037 120.719C152.157 122.529 150.876 126 148.089 126H37.9114C35.1236 126 33.8432 122.529 35.963 120.719L91.0516 73.6643Z",
    fill: "#00463A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9666 53.8746C92.1153 52.8156 93.8847 52.8156 95.0334 53.8746L141.047 96.2943C143.055 98.146 141.745 101.5 139.013 101.5H46.9866C44.2547 101.5 42.9446 98.146 44.9531 96.2943L90.9666 53.8746Z",
    fill: "#00463A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.742 29.5812C91.9373 28.2149 94.0627 28.2149 95.258 29.5812L131.949 71.5248C133.646 73.4646 132.268 76.5 129.691 76.5H56.3089C53.7316 76.5 52.354 73.4646 54.0509 71.5248L90.742 29.5812Z",
    fill: "#00463A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0522 3.45459C92.2478 1.76716 94.7522 1.76716 95.9478 3.45459L125.219 44.7656C126.627 46.7523 125.206 49.5 122.772 49.5H64.2284C61.7935 49.5 60.3729 46.7523 61.7806 44.7656L91.0522 3.45459Z",
    fill: "#00463A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/tree.07a7bc32327f5e298a88abfae7286065.svg";
export { ForwardRef as ReactComponent };